export default {
	setScreenSize: ({ commit }) => {
		commit('setScreenSize')
	},
	setLocalStorage: ({ commit }, data) => {
		commit('setLocalStorage', data)
	},
	clearLocalStorage: () => {
		localStorage.clear()
	},
	setShowIdUpdateModal: ({ commit }, value) => {
		commit('setShowIdUpdateModal', value)
	},
	setShowAnnouncement: ({ commit }, value) => {
		commit('setShowAnnouncement', value)
	},
	setCustomer({ commit, getters }) {
		const { external_client_id } = getters.activeAccount

		return axios.get(`/api/customers/${external_client_id}`).then(({ data: { data } }) => {
			const { customer } = data
			commit('setCustomer', customer)
		})
	},
	setHasDirectDebit({ commit, getters }) {
		const { external_client_id } = getters.activeAccount

		return axios.get(`/api/customers/${external_client_id}/has-direct-debits`).then(
			({
				data: {
					data: { has_direct_debit },
				},
			}) => {
				commit('setHasDirectDebit', has_direct_debit)
			}
		)
	},
	setActiveAccount({ commit }, account) {
		commit('setActiveAccount', account)
	},
	setMomoAccount({ commit, getters }) {
		const { external_client_id } = getters.activeAccount

		return axios.get(`/api/mobile-money/${external_client_id}/`).then(
			({
				data: {
					data: { mobile_money_account },
				},
			}) => {
				commit('setMomoAccount', mobile_money_account)
			}
		)
	},
	setMomoAccounts({ commit }) {
		return axios.get('/api/mobile-money').then(
			({
				data: {
					data
				},
			}) => {
				commit('setMomoAccounts', data)
			}
		)
	},
}
